import { search } from './locationSearch'

document.addEventListener('DOMContentLoaded', () => isFavoriteLocation())

function setFavoriteLocation(orderUrl, id) {
  window.localStorage.setItem('favoriteLocation', orderUrl)
  window.localStorage.setItem('favoriteLocationId', id)
  updateNavOrderBtn(orderUrl)
  toggleHeart(id)
  sortList(id)
}

function isFavoriteLocation() {
  const favoriteLocation = window.localStorage.getItem('favoriteLocation')
  const favoriteLocationId = window.localStorage.getItem('favoriteLocationId')
  if (favoriteLocation !== null && favoriteLocationId !== null) {
    updateNavOrderBtn(favoriteLocation)
    toggleHeart(favoriteLocationId)
    sortList(favoriteLocationId)
  }
}

function toggleHeart(id) {
  const target = document.querySelector(`#favorite-location-btn-${id}`)
  if (target !== null) {
    clearActiveHearts()
    target.classList.add('locations-list-item__save-location--active')
  }
}

function clearActiveHearts() {
  const target = document.querySelector(
    '.locations-list-item__save-location--active'
  )
  if (target !== null) {
    target.classList.remove('locations-list-item__save-location--active')
  }
}

function updateNavOrderBtn(orderUrl) {
  const button = document.querySelector('#order-now-nav-btn')
  if (button !== null) {
    button.href = orderUrl
  }
}

function sortList(id) {
  const target = document.querySelector(`#location-${id}`)
  if (target !== null) {
    const latitude = Number(target.dataset.latitude)
    const longitude = Number(target.dataset.longitude)
    search.searchWithOrigin(
      { lat: latitude, lng: longitude },
      { type: 'latLng' }
    )
    toggleHeart(id)
  }
}

function init() {
  window.setFavoriteLocation = setFavoriteLocation
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/favoriteLocation.js